module.exports = __webpack_public_path__ + "img/企业微信截图_1590398965701.12aea44e.png";